import { ExpandLess } from "@mui/icons-material";
import {
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  InputAdornment,
  Link as Anchor,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { sellerLogin } from "appRedux/actions/authAction";
import apiCallV2 from "appRedux/apiCallV2";
import { API_LOGIN } from "appRedux/apiType";
import Logo from "assets/logo.png";
import RegisterImage from "assets/register2.jpg";
import Loading from "common/loader";
import Input from "common/material/auth/Input";
import Toaster from "common/Toaster";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "react-phone-input-2/lib/style.css";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { loginUser } from "utils";
import { USER_NAME, USER_TOKEN } from "utils/constants";
import * as yup from "yup";
import "./Login.css";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

let registerValidate = yup.object().shape({
  password: yup.string().required("Please Enter your password"),
  email: yup.string().email().required("Email is required."),
});

const Register = () => {
  const { t } = useTranslation("login");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let token = Cookies.get(USER_TOKEN);

  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);
  const [payload, setPayload] = useState({
    email: "",
    password: "",
  });
  const [value, setValue] = useState({
    showPassword: false,
  });

  const { isUserLoggedIn } = useSelector(
    (state) => ({
      isUserLoggedIn: state.authReducer.isUserLoggedIn,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (token) navigate("/");
  }, []);

  const handleSubmit = () => {
    console.log("handleSubmit");
    registerValidate
      .validate({
        password: payload.password,
        email: payload.email,
      })
      .then((valid) => {
        console.log({ valid });
        setError({});
        setLoading(true);
        const apiPayload = {
          email_or_phone: payload.email,
          password: payload.password,
        };
        const apiData = {
          type: API_LOGIN,
          apiType: "POST",
          payload: apiPayload,
        };
        apiCallV2(apiData)
          .then((res) => {
            localStorage.setItem(USER_NAME, res.name);
            Cookies.set(USER_TOKEN, res.token);
            // dispatch(sellerLogin());
            navigate("/");
          })
          .catch((err) => showError(err))
          .finally(() => {
            setLoading(false);
          });
      })
      .catch((err) => {
        setError({ [err.path]: err.message });
      });
  };

  const showError = (data) => {
    for (const [key, value] of Object.entries(data)) {
      if (typeof value !== "string") {
        showError(value);
      } else Toaster({ type: "error", message: value });
    }
  };

  const RightLayout = () => {
    return (
      <div className="rightContainerContent">
        <div style={{ height: "100vh", width: "100%" }}>
          <img
            style={{
              height: "100%",
              width: "100%",
              objectFit: "cover",
            }}
            src={RegisterImage}
            alt="Login Cover"
          />
        </div>
        <div className="rightContainerOverlayContainer">
          <Typography mb={1} variant="headtitle1" sx={{ fontWeight: "bold" }}>
            {t("become_seller_1")}
          </Typography>
          <Typography variant="headsubtitle">{t("become_seller_2")}</Typography>
        </div>
      </div>
    );
  };

  const Header = () => {
    return (
      <div>
        <Anchor target="_blank" href="https://spacium.ae/">
          <img src={Logo} alt="Logo not found" style={{ width: "100px" }} />
        </Anchor>
        <Typography
          component="div"
          variant="h5"
          sx={{ mb: 3, fontSize: "1.9rem", mt: 3 }}
        >
          {t("title")}
          <br />
          {t("subtitle")}
          <Anchor
            target="_blank"
            href="https://spacium.ae/"
            color="primary"
            underline="none"
          >
            {" "}
            {t("subtitle_2")}
          </Anchor>
        </Typography>
        <Typography
          component="div"
          variant="subtitle1"
          sx={{ opacity: "60%", mb: 1, fontSize: "1.2rem" }}
        >
          {t("subtitle_3")}
        </Typography>
      </div>
    );
  };

  const inputs = () => {
    return (
      <>
        <Grid sx={{ mb: 2 }}>
          <Input
            value={payload.email}
            type="email"
            onChange={(e) => setPayload({ ...payload, email: e.target.value })}
            placeholder={t("email_placeholder")}
            error={error.email && error.email}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start"></InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid sx={{ mb: 3 }}>
          <Input
            value={payload.password}
            type={value.showPassword ? "text" : "password"}
            onChange={(e) =>
              setPayload({ ...payload, password: e.target.value })
            }
            placeholder="Password"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() =>
                      setValue({ ...value, showPassword: !value.showPassword })
                    }
                  >
                    {value.showPassword ? (
                      <VisibilityIcon />
                    ) : (
                      <VisibilityOffIcon />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
              startAdornment: (
                <InputAdornment position="start"></InputAdornment>
              ),
            }}
            error={error.password && error.password}
          />
        </Grid>
      </>
    );
  };

  const Footer = () => {
    return (
      <>
        <Grid
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
          }}
        >
          <FormGroup>
            <FormControlLabel
              sx={{
                "& .MuiTypography-root": {
                  fontSize: "1rem",
                  fontFamily: "Roman55",
                },
              }}
              control={<Checkbox size="small" defaultChecked />}
              label={t("keep_me_logged_in")}
            />
          </FormGroup>
          <Link to="/request-reset-password" style={{ textDecoration: "none" }}>
            <Typography
              variant="text"
              color="primary"
              sx={{
                fontFamily: "Roman55",
                textDecoration: "none",
                textTransform: "none",
                fontSize: "1rem",
              }}
            >
              {t("forget_password")}
            </Typography>
          </Link>
        </Grid>
        <Grid
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Button
            sx={{
              textTransform: "none",
              borderRadius: "20px",
              paddingLeft: "35px",
              paddingRight: "35px",
              fontFamily: "Medium65",
              fontSize: "1rem",
            }}
            disabled={loading}
            variant="contained"
            onClick={handleSubmit}
          >
            {t("primary_cta")}
            {loading ? (
              <Loading
                style={{ color: "white", marginLeft: "10px" }}
                size={20}
              />
            ) : (
              <ExpandLess
                fontSize="small"
                sx={{ transform: "rotate(90deg)", marginLeft: "10px" }}
              />
            )}
          </Button>
        </Grid>
      </>
    );
  };

  const FooterRegister = () => {
    return (
      <>
        <Divider sx={{ my: 5 }} />
        <Grid
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            my: 2,
          }}
        >
          <Typography
            variant="subtitle2"
            sx={{ fontFamily: "Roman55", fontSize: "1.1rem" }}
          >
            {t("register_text_1")}
          </Typography>
          <Link to="/register" style={{ textDecoration: "none" }}>
            <Button
              variant="text"
              color="primary"
              sx={{
                textTransform: "none",
                fontFamily: "Roman55",
                fontWeight: "bold",
                fontSize: "1.1rem",
              }}
            >
              {t("register_text_2")}
            </Button>
          </Link>
        </Grid>
      </>
    );
  };

  const hidden = useMediaQuery((theme) => theme.breakpoints.down("md"));

  return (
    <div className="mainContainer">
      <div className="leftContainer">
        <Header />
        {inputs()}
        <Footer />
        <FooterRegister />
      </div>
      {!hidden && (
        <div className="rightContainer">
          <RightLayout />
        </div>
      )}
    </div>
  );
};

export default Register;
